import { render, staticRenderFns } from "./SurveyCloserDialog.vue?vue&type=template&id=53886eb0"
import script from "./SurveyCloserDialog.vue?vue&type=script&lang=ts"
export * from "./SurveyCloserDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports